module.exports = __webpack_public_path__ + "static/media/ad8ce0ec6efbce859730eb0598a585ed.7d558213.mp4";